export const PIXEL_RATIO = window.devicePixelRatio || 1
export const VIEWPORT_RATIO = 0.98
export const PIQ_VALUES_MAP = {
  'PIQ': 'PIQ',
  'PIQOB': 'PIQOB',
  'NOB': 'NOB',
  'NOP': 'NOP',
  'OBT': 'OBT',
  'GIQOB': 'GIQOB',
  'POED': 'POED'
}

export const PIQ_OPTIONS = ['', ...Object.values(PIQ_VALUES_MAP)]
export const CODE_OPTIONS = [...Object.values(PIQ_VALUES_MAP).map((item) => ({ label: item, value: item }))]
export const DOCUMENT_SELECTION_EVENTS = {
  getValidSelections: 'get-valid-selections',
  selectionsUpdated: 'selections-updated'
}
